import React from 'react'

const Header = () => {
  return (
    <div className='header'>
        <h1>Add you Tasks</h1>
      
    </div>
  )
}

export default Header
